<template>
    <div>
        <div v-if="!em_precos">
            <div v-if="!em_edicao">

                <div class="card dashcard mb-3">
                
                    <div class="card-body">

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input icon="fas fa-search" v-model="search">
                                    <template v-slot:buttonposb>
                                        <importacao service="fornecedores" @refresh="load()" />
                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-outline-primary" @click="incluir ()">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-3 d-flex flex-column">
                                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                    @click="viewMode = 'A'">
                                        Ativos
                                    </button>
                                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                    @click="viewMode = 'T'">
                                        Todos
                                    </button>
                                </div>
                            </div>
                            <div class="col col-12 col-md-3 d-flex flex-column">
                                <az-input
                                    type="button-group"
                                    :optionsList="[
                                        { id: 'T', search: 'Todos' }, 
                                        { id: 'F', search: 'PF' }, 
                                        { id: 'J', search: 'PJ' },
                                        { id: 'O', search: 'Outros' }
                                    ]"
                                    v-model="tipo_pessoa" />
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <div v-if="!lista || !lista.length">
                <az-empty-state 
                    :msg="'Nenhum fornecedor/prestador Identificado.'" 
                    :icon="search ? 'fas fa-search' : 'fas fa-industry'"
                    action="Incluir Fornecedor/Prestador" 
                    :method="incluir" />
            </div>

            <div v-if="!em_edicao && lista && lista.length">

                <table class="table table-sm border-0 table-responsive" v-if="classes && classes.length">
                    <tr>
                        <td class="text-nowrap">
                            <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in classes" :key="icx">
                                <span class="badge badge-success mr-1" >
                                    {{ classe }}
                                </span>
                            </a>
                        </td>
                    </tr>
                </table>

                <div class="alert alert-warning" v-if="anexos_vencidos && anexos_vencidos.length">
                    <a href="#" @click.prevent="ver_vencidos = !ver_vencidos" class="alert-link">
                        {{ anexos_vencidos.length }} arquivo(s) vencido(s)
                    </a>
                </div>

                <div class="list-group mb-3 az-anime-surgir mb-3">
                    <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                        <span>
                            <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0">
                                {{ dado.search }}
                            </a>

                            <small class="text-muted mx-3" v-if="false">
                                {{ $util.formatMask(dado.st_cpf_cnpj, 'cpf-cnpj') }}
                            </small>

                            <span class="badge badge-secondary" v-if="dado.medicos && dado.medicos.length"
                                data-toggle="tooltip" data-placement="top" :title="dado.medicos.length + ' prestadore(s) vinculado(s).'">
                                {{ dado.medicos.length }}
                            </span>

                            <div v-if="dado.js_classes && dado.js_classes.length">
                                <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                    v-for="(tag, itx) in dado.js_classes" :key="itx">
                                    <span class="badge badge-success mr-1">
                                        {{ tag }}
                                    </span>
                                </a>
                            </div>
                        </span>
                        <span>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'ativo-' + id" 
                                    v-model="dado.fl_ativo" 
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'ativo-' + id"></label>
                            </div>

                            <div v-else>
                                <span v-if="dado.tipo_pessoa == 'F' || dado.tipo_pessoa == 'J'">
                                    <span class="badge" :class="dado.tipo_pessoa == 'J' ? 'badge-primary' : 'badge-info'">
                                        P{{ dado.tipo_pessoa }}
                                    </span>
                                </span>

                                <span v-if="suprimentos" class="ml-3">
                                    <button type="button" class="btn btn-outline-primary btn-sm" title="Lista de Preços" @click="abrir_lista_precos(dado)">
                                        <i class="fa-solid fa-dollar-sign"></i>
                                        <span class="badge badge-primary ml-1" v-if="dado.lista_precos_count > 0">
                                            {{ dado.lista_precos_count }}
                                        </span>
                                    </button>
                                </span>
                            </div>
                        </span>
                    </li>
                </div>

            </div>
        </div>

        <edicao-fornecedor ref="cad_fornec" :suprimentos="suprimentos" @refresh="load()" />

        <fornecedor-lista-precos ref="precos" @voltar="voltar_de_precos" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import Importacao from '../../cadastros/shared/Importacao.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import EdicaoFornecedor from './EdicaoFornecedor.vue';
import FornecedorListaPrecos from './FornecedorListaPrecos.vue';

export default {
    data () { 
        return { 
            dados: null,
            item: null, 
            search: "", 
            em_edicao: false, 
            viewMode: "A",
            validate: false, 
            impostos: [], 
            saved: true, 
            tipo_pessoa: "T", 
            ver_vencidos: false, 
            em_precos: false, 
        }
    },

    props: ['suprimentos'],

    components: { 
        AzInput, 
        Importacao, 
        AzEmptyState, 
        EdicaoFornecedor, 
        FornecedorListaPrecos, 
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            let hoje = this.$util.hoje();

            return this.dados ? 
                this.dados.filter (item => { 
                    
                    return ( item.fl_ativo || this.viewMode != 'A' ) && 
                        ( this.tipo_pessoa == 'T' || item.tipo_pessoa == this.tipo_pessoa ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                    
                })
                .filter(item => !this.ver_vencidos || item.arquivos.find(arq => arq.dt_validade && arq.dt_validade < hoje))  : [];
        },

        classes() { 
            if ( !this.dados )
                return [];

            return _.orderBy(
                    _.uniq(
                        this.dados.flatMap(item => item.js_classes ? item.js_classes : [])
                    ),
                    item => item.toUpperCase()
                );
        },

        anexos_vencidos: function () { 
            let hoje = this.$util.hoje();

            return this.lista.flatMap(item => item.arquivos ? item.arquivos.filter(item => item.dt_validade && item.dt_validade < hoje) : []);
        }
    },

    methods: { 
        voltar_de_precos () { 
            this.em_precos = false;
            this.load();
        },

        abrir_lista_precos (fornecedor) { 
            this.em_precos = true; 
            this.$refs.precos.abrir(fornecedor);
        },

        filtrar (texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = "";
            } else { 
                this.search = '"' + texto + '"';
            }
        },

        incluir () { 
            this.$refs.cad_fornec.incluir(this.classes);
        },

        editar (item) { 
            this.$refs.cad_fornec.editar(item, this.classes);
        },

        atualizar () { 
            this.$util.atualizar (this, { 
                service: 'fornecedores',
                dados: { ...this.item }, 
                modal: 'fornecedorModal', 
                reload: true, 
                callback: () => { 
                    this.$util.resync(this, 'fornecedores.index');
                }
            });
        },

        toggle (item) { 
            this.$util.toggle (this, { 
                service: 'fornecedores', 
                dados: { ...item }, 
            })
        },

        load () { 
            this.$util.load(this, { 
                service: 'fornecedores',
                parms: { 
                    cadastro: true, 
                    aquisicao: this.suprimentos ? true : false, 
                }
            });
        }
    },

    mounted () { 
        if ( this.suprimentos ) { 

            this.$store.commit("setBreadcrumb", [
                { name: "Suprimentos", path: "/suprimentos" },
                { name: "Fornecedores", path: "/suprimentos/fornecedor" }
            ]);

            if ( this.$route.path != '/suprimentos/fornecedor' ) { 
                this.$router.push({ path: '/suprimentos/fornecedor' });
            }

        } else { 

            this.$store.commit("setBreadcrumb", [
                { name: "Financeiro", path: "/financeiro/visao" },
                { name: "Fornecedores", path: "/financeiro/fornecedor" }
            ]);

            if ( this.$route.path != '/financeiro/fornecedor' ) { 
                this.$router.push({ path: '/financeiro/fornecedor' });
            }

        }

        this.load ();

        this.$util.loadItem(this, { 
            service: 'impostos',
            func: 'index',
        })
        .then(res => { 
            this.impostos = res;
        });
    },

    updated() {
        $('[data-toggle="tooltip"]').tooltip();
    },

}
</script>